import { createI18nText } from '../../functions';
var errorText = createI18nText({
    he: {
        generalShort: 'אירעה שגיאה',
        generalSystem: 'הייתה תקלה במערכת',
        fileNameTooLong: 'אחד משמות הקבצים ארוך מדי',
        googleMapsStation: {
            israelLoc: "הכתובת צריכה להיות בישראל",
            locationNotFound: "הכתובת לא נמצא",
            userExists4station: 'כבר קיימת תחנת חלוקה עבור משתמש זה'
        },
        name: 'השם המלא אינו תקין',
        phone: 'מספר הטלפון אינו תקין',
        email: 'המייל אינו תקין',
        phoneWoOther: 'אנא הכנס מספר טלפון ללא רווחים או תווים אחרים',
        associationExists: 'כבר קיימת עמותה למשתמש זה',
        associationNameExists: 'שם העמותה תפוס',
        selectAKit: 'יש לבחור לפחות מוצר אחד',
        selectAStation: 'יש לבחור תחנה',
        selectValue: 'יש לבחור סכום',
        numbersOnly: 'יש להזין ספרות בלבד',
        enterValue: 'יש להזין סכום',
        plsLogin: 'מספר טלפון זה כבר קיים במערכת, נא להתחבר',
        phoneExists: 'מספר טלפון זה כבר קיים במערכת',
        invalidInfo: 'אחד או יותר מהפרטים שהוזנו לא תקינים',
        tooHeavy: 'הקבצים שנבחרו גדולים מדי',
        hebrew: 'נא לכתוב בעברית בלבד',
        twoDrivers: 'יש להוסיף ולשמור לפחות שני נהגים',
        driversNotSaved: 'ישנם נהגים שהוספו אך לא נשמרו',
        sucksaved: 'הפרטים נשמרו בהצלחה',
        suckCopied: 'הקישור הועתק בהצלחה',
        downloadFile: 'הייתה תקלה בהורדת הקובץ',
        suckDeleteAsso: 'העמותה נמחקה בהצלחה'
    },
    en: {
        generalShort: 'An error occurred',
        generalSystem: 'An error occurred',
        fileNameTooLong: 'One of the files\' name is too long',
        googleMapsStation: {
            israelLoc: 'The address must be in Israel',
            locationNotFound: 'The address was not found',
            userExists4station: 'A distribution station already exists under this user'
        },
        name: 'The name is not valid',
        phone: 'The phone number is not valid',
        email: 'The email is not valid',
        phoneWoOther: 'Please enter a mobile number without any spaces or dashes',
        associationExists: 'An association already exists under this user',
        associationNameExists: 'The association name already exists',
        selectAKit: 'Please select at least one kit',
        selectAStation: 'Please select a station',
        selectValue: 'Please select a sum',
        numbersOnly: 'Please enter only digets',
        enterValue: 'Please enter a value',
        plsLogin: 'The phone number already exists in the system, please log in',
        phoneExists: 'The phone number already exists in the system',
        invalidInfo: 'One or more of the details entered are invalid',
        tooHeavy: 'The files selected are too heavy',
        hebrew: 'Please use Hebrew text only',
        twoDrivers: 'Please add at least two drivers',
        driversNotSaved: 'There are drivers that were added but were not saved',
        sucksaved: 'The details were saved successfully',
        suckCopied: 'The link has been copied successfully',
        downloadFile: 'An error occurred while trying to download the file',
        suckDeleteAsso: 'The association was deleted successfully'
    }
});
export default errorText;
//# sourceMappingURL=errorText.js.map